import { MainContent, SubTitle, Text, Img } from 'src/components/contents/direction/DirectionPage';
import Direction01 from 'src/assets/images/direction/cert/cert_direction_mobile_01.svg';
import Direction02 from 'src/assets/images/direction/cert/cert_direction_mobile_02.svg';
import Direction03 from 'src/assets/images/direction/cert/cert_direction_mobile_03.svg';
import Direction04 from 'src/assets/images/direction/cert/cert_direction_mobile_04.svg';
import Direction05 from 'src/assets/images/direction/cert/cert_direction_mobile_05.svg';
import { Link } from 'react-router-dom';

interface Iprops {
  color?: string;
}

/**
 * 電子證書操作說明行動版。
 */
const CertDirectionMobile: React.FC<Iprops> = ({ color }) => {
  return (
    <MainContent>
      <p>電子證書系統提供電子證書驗證與下載服務；以下是其操作說明。</p>
      <SubTitle>電子證書入口：</SubTitle>
      <Text>
        1. 進入
        <Link to={process.env.PUBLIC_URL === '' ? "/" : process.env.PUBLIC_URL} style={{ color: color }}>
          權證查詢系統
        </Link>
        。
      </Text>
      <Text>2. 點擊「電子證書」。</Text>
      <Img src={Direction01} />
      <SubTitle>電子證書驗證：</SubTitle>
      <Text>1. 您可點擊「選擇檔案」區塊將電子證書 pdf 檔上傳。</Text>
      <Img src={Direction02} />
      <Text>2. 輸入驗證碼後，按下「送出驗證」按鈕，即可查詢驗證結果。</Text>
      <Img src={Direction03} />
      <SubTitle>下載證書：</SubTitle>
      <Text>1. 填寫完整專利證書號數或商標註冊號數，以及下載碼。</Text>
      <Text>2. 輸入驗證碼後，按下「下載」按鈕，即可查詢證書檔案。</Text>
      <Img src={Direction04} />
      <Text>3. 點擊 pdf 連結，即可下載證書。</Text>
      <Img src={Direction05} />
    </MainContent>
  );
};

export default CertDirectionMobile;
